import { render } from "./CertificateContent.vue?vue&type=template&id=e278a5da&scoped=true"
import script from "./CertificateContent.vue?vue&type=script&lang=js"
export * from "./CertificateContent.vue?vue&type=script&lang=js"

import "./CertificateContent.vue?vue&type=style&index=0&id=e278a5da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e278a5da"]])

export default __exports__